<script>
    import { currency_formatter } from "../../globals.js";
    import { init_data } from "../../init.js";
    import { transactions_store } from "../../stores.js";
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push } from "svelte-spa-router";
    import { formatDateAndTime, formatDate, sort_functions } from '../../utils/format.js';


    let transactions = [];
    let is_busy = false;
    let date_value = "";
    let is_mounted = false;

    $: content_title = "Payment Report";

    onMount(async () => {
        setTimeout(()=>{ is_mounted = true; }, 250);
        init_data('transactions');
    });

    transactions_store.subscribe(value => {
        let temp_transactions = [];
        for (let index in value) {
            temp_transactions.push({
                'id': value[index].jid,
                'prid': ('000000' + value[index].id).slice(-6),
                'type': value[index].transaction_type ? value[index].transaction_type.charAt(0).toUpperCase() + value[index].transaction_type.slice(1) : '',
                'c': `<a sortValue='${value[index].client}' href='/#/User_Review?uid=${value[index].huid}'>${value[index].client}</a>`,
                'client_name': value[index].client,
                'pm': value[index].paymethod ? value[index].paymethod.charAt(0).toUpperCase() + value[index].paymethod.slice(1) : '',
                'p': `${value[index].amount}`,
                'd': formatDateAndTime(value[index].date),
                'dt': formatDate(value[index].date)
            })
        }
        transactions = temp_transactions;
    });

    let table_header_config = [
        {'t': 'Payment #', 'fm': 'prid', 'csv': 'prid', 'a': true},
        {'t': 'Type', 'fm': 'type', 'csv': 'type', 'a': true},
        {'t': 'Client', 'fm': 'c', 'csv': 'client_name', 'a': true},
        {'t': 'Payment Method', 'fm': 'pm', 'csv': 'pm', 'a': true},
        {'t': 'Amount', 'fm': 'p', 'csv': 'p', 'a': true},
        // {'t': 'Note', 'fm': 'note', 'csv': 'note', 'a': true},
        {'t': 'Date', 'fm': 'd', 'csv': 'd', 'a': true},
    ];

    let show_items = [{"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => {push("#/Job_Review?jid=" + id); }}];
    // let action_items = [
    //     {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => {push("#/Invoice_Review?iid=" + id); }},
    //     // {"id": "edit", "i": "fas fa-edit", "s": "color: #ff9800;", "f": (id) => {push("#/Invoice_Edit?iid=" + id); }},
    //     {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {console.log(`whould be deleting id: ${id}`);}},
    // ];
    
    let field_formats = {
        "p": (p) => {
            if(typeof(p) === "string" && !p.startsWith("$")){
                return currency_formatter.format(parseFloat(p));
            } else {
                return p;
            }
        }
    };

    let field_styles = {
        "p": "text-align: right;"
    }

    let grand_total = "$0.00";

    function update_grand_total(payments_to_total) {
        let tot = 0.00;
        for(let i = 0; i < payments_to_total.length; i++){
            let np = payments_to_total[i];
            if(np.p !== undefined){
                tot = tot + parseFloat(np.p.toString().replace("$", ""));
            }
        }
        grand_total =  currency_formatter.format(tot);

    }
</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">    
    <div class="section">
        <div class="sectionsubtitle">Payment Summary - Total: {grand_total}</div>
        <div class="invoicetableholder">
            <ResponsiveTable 
                field_formats={field_formats}
                field_styles={field_styles}
                sort_functions={sort_functions}
                num_per_page={100}
                show_date_range={true}
                table_filtered_function={update_grand_total}
                date_filter_param='dt'
                refresh_action='transactions'
                show_csv_export={true}
                bind:table_header_config={table_header_config}
                bind:table_data={transactions}
                bind:date_value={date_value}
                bind:total_items={transactions.length}
                bind:show_items={show_items}
            />
        </div>
    </div>
</div>


<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }
    :global(.flatpickr-input) {
        width: 250px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
    }
</style>